export function isVeBetterDaoNavigatorFee(tx = {}, classification = '') {
  const cls = String(classification || tx.classification || tx.type || '')
    .trim()
    .toLowerCase();
  if (cls !== 'governance_reward') return false;

  const semanticType = String(tx.providerSemanticType || '').trim().toLowerCase();
  const protocolClass = String(tx.protocolClassification || '').trim().toLowerCase();
  const economicEventType = String(tx.economicEventType || '').trim().toLowerCase();
  const incomeSource = String(tx.incomeSource || '').trim().toLowerCase();

  return (
    semanticType === 'vebetterdao_navigator_fee_claim' ||
    protocolClass === 'navigator_fee_claim' ||
    economicEventType === 'navigator_service_fee' ||
    incomeSource === 'vebetterdao_navigator_fee'
  );
}

export function getVeBetterDaoNavigatorFeeDisplay(
  tx = {},
  classification = '',
  language = 'en'
) {
  if (!isVeBetterDaoNavigatorFee(tx, classification)) return null;

  return {
    title: 'VeBetterDAO Navigator',
    subtitle: language === 'de' ? 'Navigator-Gebühr' : 'Navigator Fee',
  };
}

export function getVeBetterDaoNavigatorDisplay(
  tx = {},
  classification = '',
  language = 'en'
) {
  const cls = String(classification || tx.classification || tx.type || '')
    .trim()
    .toLowerCase();

  if (cls === 'vebetterdao_navigator_stake_deposit') {
    return {
      title: 'VeBetterDAO Navigator',
      subtitle: language === 'de' ? 'Stake-Einzahlung' : 'Stake Deposit',
      tone: 'out',
    };
  }

  if (cls === 'vebetterdao_navigator_stake_withdrawal') {
    return {
      title: 'VeBetterDAO Navigator',
      subtitle: language === 'de' ? 'Stake-Auszahlung' : 'Stake Withdrawal',
      tone: 'in',
    };
  }

  const fee = getVeBetterDaoNavigatorFeeDisplay(tx, cls, language);
  return fee ? { ...fee, tone: 'in' } : null;
}
